import React, { useEffect, useState } from 'react';
import { ExamResults } from './exam-results';
import { useTranslation } from 'react-i18next';
export const ExaminationResults = ({ exams, examinationcode, language, isLaw2022Student, studentTechnicalErrors }) => {
    const [maximumQuestions, setMaximumQuestions] = useState(0);
    const [lastCompletedExamIndex, setLastCompletedExamIndex] = useState(0);
    useEffect(() => {
        setMaximumQuestions(Math.max(...exams.map(exam => {
            if (exam.questionScores) {
                return exam.questionScores.flatMap(score => score).length;
            }
            else {
                return 0;
            }
        })));
        const firstIncompleteExam = exams.find(exam => !exam.questionScores);
        const firstIncompleteExamIndex = firstIncompleteExam ? exams.indexOf(firstIncompleteExam) : exams.length;
        setLastCompletedExamIndex(firstIncompleteExamIndex - 1);
    }, [exams]);
    return (React.createElement("div", { className: "examination-results" },
        React.createElement("table", null,
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { colSpan: 5 }, getExaminationTitle(examinationcode)),
                    maximumQuestions > 0 &&
                        Array(maximumQuestions)
                            .fill(undefined)
                            .map((_, index) => (React.createElement("th", { key: index, className: "question-score" }, index + 1))))),
            React.createElement("tbody", null, exams.map((exam, index) => {
                const examTechnicalError = studentTechnicalErrors
                    ? getTechnicalErrorForExam(exam.examUuid, exam.examinationcode, studentTechnicalErrors)[0]
                    : undefined;
                return (React.createElement(ExamResults, { exam: exam, maximumQuestions: maximumQuestions, lastCompletedExam: index === lastCompletedExamIndex, language: language, isLaw2022Student: isLaw2022Student, key: index, examTechnicalError: examTechnicalError }));
            })))));
};
const getTechnicalErrorForExam = (examUuid, examinationcode, technicalErrors) => technicalErrors.filter(error => error.examUuid == examUuid && error.examinationcode == examinationcode);
const getExaminationTitle = (examinationcode) => {
    const { t } = useTranslation();
    const year = examinationcode.substring(0, 4);
    const season = examinationcode[4] === 'K' ? 'spring' : 'autumn';
    return (React.createElement(React.Fragment, null,
        year,
        " ",
        t(season)));
};
//# sourceMappingURL=examination-results.js.map